var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-carousel',{attrs:{"continuous":true,"cycle":true,"show-arrows":false,"hide-delimiters":true,"height":"96"}},_vm._l((_vm.slides),function(slide,i){return _c('v-carousel-item',{key:i,on:{"click":function($event){$event.stopPropagation();return (function () {
      _vm.$emit('tap');
      _vm.$emit('change', slide);
    })($event)}}},[_vm._t("item",null,{"slide":slide})],2)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }